<template>
  <div class="roadContainer">
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleChange">
      <el-tab-pane label="广州重要交通枢纽精细化预报" name="traffic">
        <div class="sevenDays">
          <seven-days-gift-map
            ref="sevenDays"
            :showTitle="false"
          ></seven-days-gift-map>
          <button @click="closeBox">关闭</button>
        </div>
        <div id="map"></div>
      </el-tab-pane>
      <el-tab-pane label="广州市重点通道实时路况" name="road">
        <!-- <iframe class="iframeRoad" src="http://jt.weather.com.cn/roadcondition/" frameborder="0"></iframe> -->
        <div class="gdMap">
          <iframe id="road" :src="road" width="100%" height="100%"></iframe>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import sevenDaysGiftMap from './sevenDaysGiftMap.vue'
import BMap from 'BMap'
import BMapLib from '@/assets/js/BMapLib_GeoUtils.js'
export default {
  components: {
    sevenDaysGiftMap
  },
  data () {
    return {
      activeName: 'traffic',
      road: 'http://tqyb.com.cn/road1/',
      map: '',
      gzPolygon: '',
      cPoint: [113.271001, 23.135916],
      chezhanArray: [
        { name: '省汽车客运站', addr: '广州市环市西路147-149号', point: [113.259719, 23.154236] },
        { name: '市汽车客运站', addr: '广州市环市西路158号', point: [113.259647, 23.153439] },
        { name: '天河客运站', addr: '燕岭路633号', point: [113.35038, 23.176465] },
        { name: '芳村汽车客运站', addr: '广州花地大道中51号', point: [113.240797, 23.086168] },
        { name: '越秀南客运站', addr: '广州市越秀南路东园横路2号', point: [113.2841, 23.124776] },
        { name: '罗冲围客运站', addr: '广州市增槎路251—255号', point: [113.229581, 23.154394] },
        { name: '滘口汽车站', addr: '芳村大道西533号', point: [113.21489, 23.121095] },
        { name: '广园客运站', addr: '广州市广园中路283号', point: [113.278874, 23.165135] },
        { name: '海珠客运站', addr: '广州南洲路182号', point: [113.306333, 23.0703] },
        { name: '广佛汽车站', addr: '广州市中山八路95号', point: [113.239814, 23.130991] },
        { name: '东圃客运站', addr: '广州市中山大道东1011号', point: [113.422365, 23.125607] },
        { name: '夏茅汽车站', addr: '机场路夏茅村口', point: [113.267433, 23.235239] },
        { name: '永泰汽车站', addr: '白云大道北271号（临）', point: [113.314347, 23.242818] },
        { name: '黄埔客运站', addr: '广州市黄埔广深公路以南石化路以东段', point: [113.474726, 23.102523] },
        { name: '东站客运站', addr: '广州市天河区禺东西路43号', point: [113.329778, 23.158548] },
        { name: '南站客运站', addr: '广州市番禺区钟村南站南路', point: [113.280885, 22.995918] }
      ],
      chezhanMarketArray: [],
      matouMarketArray: [],
      matouArray: [
        { name: '西堤码头', addr: '西堤码头', point: [113.258575, 23.11321] },
        { name: '广州塔码头', addr: '广州塔码头', point: [113.32743, 23.113093] },
        { name: '金沙洲码头', addr: '金沙洲码头', point: [113.221552, 23.161347] }
      ],

      gangkouMarketArray: [],
      gangkouArray: [
        { name: '广州港', addr: '广州港', point: [113.458388, 23.099748] },
        { name: '南沙港', addr: '南沙港', point: [113.596377, 22.80594] },
        { name: '莲花山港', addr: '莲花山港', point: [113.513031, 22.973551] }
      ],

      huocheMarketArray: [],
      huocheArray: [
        { name: '广州站', addr: '广州站', point: [113.264213, 23.154868] },
        { name: '广州东站', addr: '广州东站', point: [113.332205, 23.156263] },
        { name: '广州南站', addr: '广州南站', point: [113.277259, 22.995818] },
        { name: '广州北站', addr: '广州北站', point: [113.211203, 23.382947] }
      ],
      feijiMarketArray: [],
      feijiArray: [
        { name: '白云机场', addr: '白云机场', point: [113.309493, 23.392435] }

      ],
      yjMarketArray: [],
      yjpointArray: [
        { name: '广东奥林匹克体育中心', addr: '广东奥林匹克体育中心', point: [113.416811, 23.145979] },
        { name: '黄埔区体育中心', addr: '黄埔区体育中心', point: [113.463035, 23.12077] },
        { name: '广州体育馆', addr: '广州体育馆', point: [113.284057, 23.187879] },
        { name: '广交会展馆', addr: '广交会展馆', point: [113.367982, 23.107182] },
        { name: '广州体育学院', addr: '广州体育学院', point: [113.325457, 23.149434] },
        { name: '天河体育中心', addr: '天河体育中心', point: [113.33143, 23.143957] },
        { name: '大学城体育中心', addr: '大学城体育中心', point: [113.397292, 23.0609] },
        { name: '大学城广东科学中心', addr: '大学城广东科学中心', point: [113.369063, 23.045285] },
        { name: '花都区体育中心', addr: '花都区体育中心', point: [113.22666, 23.390722] },
        { name: '花都区实验中学', addr: '花都区实验中学', point: [113.218168, 23.382401] },
        { name: '花都区秀全中学', addr: '花都区秀全中学', point: [113.216759, 23.448906] },
        { name: '新华街第二小学', addr: '新华街第二小学', point: [113.217722, 23.380975] },
        { name: '花都区邝维煜中学', addr: '花都区邝维煜中学', point: [113.210722, 23.405983] },
        { name: '花都区圆玄中学', addr: '花都区圆玄中学', point: [113.221263, 23.415293] },
        { name: '花都区云山中学', addr: '花都区云山中学', point: [113.234923, 23.402337] },
        { name: '花都区体育馆', addr: '花都区体育馆', point: [113.217526, 23.385418] }],
      windCont: ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风', '北风']

    }
  },
  methods: {
    // 关闭七天精细化弹框
    closeBox () {
      const sevenContainer = document.getElementsByClassName('sevenDays')[0]
      sevenContainer.style.display = 'none'
    },
    handleChange () {
      this.road = `http://tqyb.com.cn/road1/?random=${Math.random}`
    },
    showBoundary (city) {
      const thisObj = this
      const bdary = new BMap.Boundary()
      bdary.get(city, function (rs) {
        thisObj.map.clearOverlays()
        var count = rs.boundaries.length
        for (var i = 0; i < count; i++) {
          thisObj.gzPolygon = new BMap.Polygon(rs.boundaries[i], { strokeWeight: 2, strokeColor: '#ff0000', fillColor: null, fillOpacity: 0.1, strokeStyle: 'dashed' }) // 建立多边形覆盖物
          thisObj.map.addOverlay(thisObj.gzPolygon)
        }
        thisObj.mapMarker = new BMap.Marker(new BMap.Point(thisObj.cPoint[0], thisObj.cPoint[1])) // 创建标注
        thisObj.map.addOverlay(thisObj.mapMarker)
        thisObj.serchCheZhan(1)
        thisObj.serchCheZhan(2)
        thisObj.serchCheZhan(3)
        thisObj.serchCheZhan(4)
        thisObj.serchCheZhan(5)
        thisObj.serchCheZhan(6)
        // thisObj.initMapCallbac()
      })
    },
    serchCheZhan (index) {
      const thisObj = this
      let itm = null
      if (index === 1) {
        for (let i = 0; i < thisObj.chezhanArray.length; i++) {
          itm = thisObj.chezhanArray[i]
          thisObj.chezhanMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/chezhan.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.chezhanMarketArray[i])
          thisObj.chezhanMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 2) {
        for (let i = 0; i < thisObj.matouArray.length; i++) {
          itm = thisObj.matouArray[i]
          thisObj.matouMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/matou.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.matouMarketArray[i])
          thisObj.matouMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 3) {
        for (let i = 0; i < thisObj.gangkouArray.length; i++) {
          itm = thisObj.gangkouArray[i]
          thisObj.gangkouMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/gangkou.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.gangkouMarketArray[i])
          thisObj.gangkouMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 4) {
        for (let i = 0; i < thisObj.huocheArray.length; i++) {
          itm = thisObj.huocheArray[i]
          thisObj.huocheMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/hc2019.png', new BMap.Size(36, 46), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.huocheMarketArray[i])
          thisObj.huocheMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 5) {
        for (let i = 0; i < thisObj.feijiArray.length; i++) {
          itm = thisObj.feijiArray[i]
          thisObj.feijiMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/jc2019.png', new BMap.Size(36, 46), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.feijiMarketArray[i])
          thisObj.feijiMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 6) {
        for (var i = 0; i < thisObj.yjpointArray.length; i++) {
          itm = thisObj.yjpointArray[i]
          thisObj.yjMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/yj.png', new BMap.Size(24, 30), { anchor: new BMap.Size(10, 25) }, { imageOffset: new BMap.Size(0, 0) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.yjMarketArray[i])
          thisObj.yjMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      }
    },
    loadDataAndChange (e) {
      // $('#forecast-popup').hide()
      var thisObj = this
      if (BMapLib.GeoUtils.isPointInPolygon(new BMap.Point(e.point.lng, e.point.lat), thisObj.gzPolygon) === false) {
        alert('超出查询范围！ 请选择广州范围内的点。')
      }
      thisObj.cPoint[0] = e.point.lng
      thisObj.cPoint[1] = e.point.lat
      // var httpUrl = thisObj.baiduApi + thisObj.cPoint[1] + ',' + thisObj.cPoint[0]

      thisObj.mapMarker.show()
      thisObj.mapMarker.setPosition(new BMap.Point(thisObj.cPoint[0], thisObj.cPoint[1]))
      // vanwins.view.createScriptNoCache(httpUrl, null)

      // thisObj.loadData(thisObj.cPoint[0], thisObj.cPoint[1])
      // console.log(thisObj.cPoint)
      this.$refs.sevenDays.refresh(thisObj.cPoint)
      const sevenContainer = document.getElementsByClassName('sevenDays')[0]
      sevenContainer.style.display = 'block'
    }
  },
  mounted () {
    this.map = new BMap.Map('map')
    this.map.centerAndZoom(new BMap.Point(this.cPoint[0], this.cPoint[1]), 10)
    this.map.addControl(new BMap.NavigationControl())
    this.map.addControl(new BMap.ScaleControl())
    this.map.addControl(new BMap.MapTypeControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, mapTypes: [BMAP_SATELLITE_MAP, BMAP_HYBRID_MAP, BMAP_NORMAL_MAP] }))
    this.map.enableScrollWheelZoom()
    this.showBoundary('广州')
    this.map.setCurrentCity('广州')
    this.map.addEventListener('click', this.loadDataAndChange)
  }
}
</script>

<style lang="less">
.roadContainer {
  position: relative;
  .tabs {
    position: relative;
    .el-tabs__header {
      position: absolute;
      top: -50px;
    }
    .el-tabs__content {
      position: relative;
      bottom: 0;
    }
  }
  .sevenDays {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 790px;
    // height: 320px;
    border: 10px solid skyblue;
    padding: 10px 10px 0 0;
    background-color: white;
    button {
      position: absolute;
      right: 0;
      top: 0;
      color: red;
      font-size: 12px;
    }
  }
  #map {
    width: 850px;
    height: 470px;
  }
  .gdMap {
    width: 100%;
    height: 470px;
  }
}
</style>
